<div class="navigation-wrapper">
  <div class="navigation-menu">
    <div class="navigation-menu-left">
      <div class="navigation-container">
        <div class="menu-items">
          <div class="menu-item no-submenu">
            <div class="menu-link underlined">
              <a href="https://www.sqi.gouv.qc.ca/expertises"> Expertises </a>
            </div>
          </div>
          <div class="menu-item no-submenu">
            <div class="menu-link underlined">
              <a href="https://www.sqi.gouv.qc.ca/faire-affaire-avec-la-sqi">
                Faire affaire avec la SQI
              </a>
            </div>
          </div>
          <div class="menu-item no-submenu">
            <div class="menu-link underlined">
              <a href="https://www.sqi.gouv.qc.ca/emplois"> Emplois </a>
            </div>
          </div>
          <div class="menu-item no-submenu">
            <div class="menu-link underlined">
              <a href="https://www.sqi.gouv.qc.ca/actualites"> Actualités </a>
            </div>
          </div>
          <div class="menu-item no-submenu">
            <div class="menu-link underlined">
              <a href="https://www.sqi.gouv.qc.ca/a-propos"> À propos </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="navigation-menu-right">
      <div class="navigation-container right-menu">
        <div class="menu-items">
          <div class="menu-item others">
            <div class="menu-link underlined">
              <a href="" class=""> Plus </a
              ><a id="menu-toggle-button" class="menu-toggle"
                ><img
                  src="assets/images/chevron-down-solid.svg"
                  width="30"
                  height="30"
              /></a>
            </div>
            <div class="sub-menu">
              <div class="menu-content">
                <div class="sub-menu-item menu-plus">
                  <a href="https://www.sqi.gouv.qc.ca/expertises">Expertises</a
                  ><a class="sub-menu-toggle"
                    ><img
                      src="assets/images/next-blue.svg"
                      width="30"
                      height="30"
                  /></a>
                </div>
                <ul class="sub-sub-menu">
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/expertises/gestion-de-projets"
                      >Gestion de projets</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/expertises/gestion-immobiliere"
                      >Gestion immobilière</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/expertises/pratiques-integrees-bim-pci"
                      >Pratiques intégrées BIM-PCI</a
                    >
                  </li>
                </ul>
                <div class="sub-menu-item menu-plus">
                  <a href="https://www.sqi.gouv.qc.ca/faire-affaire-avec-la-sqi"
                    >Faire affaire avec la SQI</a
                  ><a class="sub-menu-toggle"
                    ><img
                      src="assets/images/next-blue.svg"
                      width="30"
                      height="30"
                  /></a>
                </div>
                <ul class="sub-sub-menu">
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/faire-affaire-avec-la-sqi/appels-doffres-et-resultats"
                      >Appels d'offres et résultats</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/faire-affaire-avec-la-sqi/ouverture-des-soumissions-en-direct"
                      >Ouverture des soumissions en direct</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/faire-affaire-avec-la-sqi/avis-dinteret"
                      >Avis d'intérêt</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/faire-affaire-avec-la-sqi/recherche-despaces"
                      >Recherche d'espaces</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/faire-affaire-avec-la-sqi/immeubles-a-vendre"
                      >Immeubles à vendre</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/faire-affaire-avec-la-sqi/outils-pour-les-partenaires"
                      >Outils pour les partenaires</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/faire-affaire-avec-la-sqi/concessions-alimentaires"
                      >Concessions alimentaires</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/faire-affaire-avec-la-sqi/rapports-de-verification-de-processus"
                      >Rapports de vérification de processus</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/faire-affaire-avec-la-sqi/ethique-et-lobbyisme"
                      >Éthique et lobbyisme</a
                    >
                  </li>
                </ul>
                <div class="sub-menu-item menu-plus">
                  <a href="https://www.sqi.gouv.qc.ca/emplois">Emplois</a
                  ><a class="sub-menu-toggle"
                    ><img
                      src="assets/images/next-blue.svg"
                      width="30"
                      height="30"
                  /></a>
                </div>
                <ul class="sub-sub-menu">
                  <li>
                    <a href="https://pilierdevotreavenir.com/"
                      >Emplois disponibles</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/accueil/emplois/avantages"
                      >Avantages</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/accueil/emplois/domaines-demploi"
                      >Domaines d'emploi</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/accueil/emplois/stages-et-emplois-etudiants"
                      >Stages et emplois étudiants</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/accueil/emplois/domaines-demploi/recrutement-international"
                      >Recrutement international</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/accueil/emplois/emplois-pour-les-personnes-retraitees"
                      >Emplois pour les personnes retraitées</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/accueil/emplois/communiquez-avec-notre-equipe-de-recrutement"
                      >Communiquez avec notre équipe de recrutement</a
                    >
                  </li>
                </ul>
                <div class="sub-menu-item menu-plus">
                  <a href="https://www.sqi.gouv.qc.ca/actualites">Actualités</a>
                </div>
                <ul class="sub-sub-menu">
                  <li>
                    <a href="https://www.sqi.gouv.qc.ca/actualites/details"
                      >Détails</a
                    >
                  </li>
                  <li>
                    <a href="https://www.sqi.gouv.qc.ca/actualites/rechercher"
                      >Rechercher</a
                    >
                  </li>
                </ul>
                <div class="sub-menu-item menu-plus">
                  <a href="https://www.sqi.gouv.qc.ca/a-propos">À propos</a
                  ><a class="sub-menu-toggle"
                    ><img
                      src="assets/images/next-blue.svg"
                      width="30"
                      height="30"
                  /></a>
                </div>
                <ul class="sub-sub-menu">
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/a-propos/mission-vision-et-valeurs"
                      >Mission, vision et valeurs</a
                    >
                  </li>
                  <li>
                    <a href="https://www.sqi.gouv.qc.ca/a-propos/ministre"
                      >Ministre</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/a-propos/conseil-dadministration"
                      >Conseil d'administration</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/a-propos/comite-de-direction-et-organigramme"
                      >Comité de direction et organigramme</a
                    >
                  </li>
                  <li>
                    <a href="https://www.sqi.gouv.qc.ca/a-propos/publications"
                      >Publications</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/a-propos/developpement-durable"
                      >Développement durable</a
                    >
                  </li>
                  <li>
                    <a href="https://www.sqi.gouv.qc.ca/a-propos/certifications"
                      >Certifications</a
                    >
                  </li>
                  <li>
                    <a href="https://www.sqi.gouv.qc.ca/a-propos/nous-joindre"
                      >Nous joindre</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/a-propos/declaration-de-services-a-la-clientele"
                      >Déclaration de services à la clientèle</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/a-propos/indicateurs-de-performance"
                      >Indicateurs de performance</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/expertises/gestion-immobiliere/registre-des-immeubles-patrimoniaux"
                      >Registre des immeubles patrimoniaux</a
                    >
                  </li>
                  <li>
                    <a href="https://www.sqi.gouv.qc.ca/a-propos/netiquette"
                      >Nétiquette</a
                    >
                  </li>
                  <li>
                    <a href="https://www.sqi.gouv.qc.ca/a-propos/accessibilite"
                      >Accessibilité</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/a-propos/politique-de-confidentialite"
                      >Politique de confidentialité</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.sqi.gouv.qc.ca/a-propos/acces-a-linformation"
                      >Accès à l'information</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
